export default __webpack_public_path__ + "static/media/photo-camera.be965718.svg";